<template>
  <div>
    <highcharts :options="chartOptions"></highcharts>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Chart } from 'highcharts-vue';

@Component({
    name: 'd-toneLine',
    components: {
        highcharts: Chart
    }
})
export default class DSocialToneLine extends Vue {
    @Prop({
        required: false,
        default: null
    })
    selectPeriod; // произвольный период

    @Prop({
        required: false,
        default: null
    })
    theme; // выбранная тема

    @Prop({
        required: true,
        default: {}
    })
    period; // выбранный период

    @Prop({
        required: true,
        default: []
    })
    datas; // массив постов

    @Prop({
        required: false,
        default: []
    })
    unrelevants; // нерелевантные посты

    chartOptions = {};
    month = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

    created() {
        this.$watch('datas', () => {
            this.updateOptions();
        });
    }

    mounted() {
        this.updateOptions();
    }

    updateOptions() {
        const colors = ['#1f4e79', '#f8cbad', '#bfbfbf', '#3b7cb7', '#e37979', '#bdd7ee'];
        const series = [];
        const categories = new Set();

        let total = new Map();
        let negative = new Map();
        let neutral = new Map();
        let positive = new Map();

        let dt = new Date();
        let date = null;

        let valPeriod = this.period.value;
        if ((this.period.value === null) && (this.period.selectPeriod)) {
            valPeriod = Math.round((this.selectPeriod[1] - this.selectPeriod[0]) / 86400000);
        }

        this.datas.forEach((item) => {
            if (this.unrelevants.indexOf(item.id) === -1) {
                if (valPeriod === 1) {
                    if ((date !== new Date(item.bDate).toLocaleDateString('en-GB'))
            || (dt === (new Date(item.bDate).toLocaleDateString('en-GB') + ' ' + new Date(item.bDate).getHours() + ':00'))) {
                        dt = new Date(item.bDate).toLocaleDateString('en-GB') + ' ' + new Date(item.bDate).getHours() + ':00';
                    } else {
                        dt = new Date(item.bDate).getHours() + ':00';
                    }
                }
                if ((valPeriod > 1) && (valPeriod < 31)) {
                    dt = new Date(item.bDate).toLocaleDateString('en-GB');
                }
                if ((valPeriod > 30) || (valPeriod === null)) {
                    dt = this.month[new Date(item.bDate).getMonth()];
                }
                date = new Date(item.bDate).toLocaleDateString('en-GB');
                categories.add(dt);

                switch (item.tone) {
                    case -2:
                        negative = this.mapValue(negative, dt);
                        break;
                    case 1:
                        neutral = this.mapValue(neutral, dt);
                        break;
                    case 2:
                        positive = this.mapValue(positive, dt);
                        break;
                    default:
                        break;
                }
                total = this.mapValue(total, dt);
            }
        });

        const totalDatas = [];
        const negativeDatas = [];
        const neutralDatas = [];
        const positiveDatas = [];
        for (const c of categories) {
            totalDatas.push(total.get(c) === undefined ? 0 : total.get(c));
            negativeDatas.push(negative.get(c) === undefined ? 0 : negative.get(c));
            neutralDatas.push(neutral.get(c) === undefined ? 0 : neutral.get(c));
            positiveDatas.push(positive.get(c) === undefined ? 0 : positive.get(c));
        }
        series.push({ name: 'Всего', data: totalDatas });
        series.push({ name: 'Негативная', data: negativeDatas });
        series.push({ name: 'Нейтральная', data: neutralDatas });
        series.push({ name: 'Позитивная', data: positiveDatas });

        this.chartOptions = {
            colors,
            chart: {
                type: 'line',
                height: 500
            },
            title: {
                text: (this.$route.name === 'Topic' ? 'Хронология публикаций' : ''),
                style: {
                    color: '#5e5e5e',
                    fontSize: '1rem'
                }
            },
            xAxis: {
                gridLineWidth: 0,
                labels: {
                    autoRotation: [90],
                    style: {
                        color: '#9cb3ce',
                        fontSize: '.9rem'
                    }
                },
                tickWidth: 0,
                tickInterval: ((valPeriod === null) ? 2 : 1),
                categories: Array.from(categories)
            },
            yAxis: {
                title: '',
                labels: {
                    style: {
                        color: '#5e5e5e',
                        fontSize: '.9rem'
                    }
                }
            },
            legend: {
                itemStyle: {
                    color: '#5e5e5e',
                    fontSize: '.9rem',
                    fontWeight: 'normal'
                }
            },
            plotOptions: {
                line: {
                    dataLabels: {
                        enabled: true
                    },
                    showInLegend: true
                },
                series: {
                    dataLabels: {
                        formatter() {
                            return '<span style="color: ' + this.point.color + '">' + this.y + '</span>';
                        },
                        style: {
                            fontSize: '.8rem',
                            fontWeight: 'normal',
                            textOutline: '0px'
                        }
                    }
                }
            },
            series: series,
            credits: {
                enabled: false
            }
        };
    }

    mapValue(map, date) {
        if (map.size === 0) {
            map = new Map();
            map.set(date, 1);
        } else {
            if (map.get(date) === undefined) {
                map.set(date, 1);
            } else {
                let val = map.get(date);
                val++;
                map.set(date, val);
            }
        }
        return map;
    }
}

</script>